import React from "react";

function IllustrationEstimatedMarketValue() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96">
      <path
        d="M82.875 56.332H25.66v2.95H84.35c.443 0 .737-.148 1.032-.443.295-.295.443-.59.443-1.032v-34.95h-2.95v33.475z"
        className="fill-primary"
      />
      <path
        d="M91.429 12.83h-68.72V4.423c0-.885-.59-1.475-1.474-1.475h-4.129c-.885 0-1.475.59-1.475 1.475v8.405H4.424c-.885 0-1.475.59-1.475 1.475v4.13c0 .884.59 1.474 1.475 1.474h11.355v72.995h7.078V19.908H91.43c.884 0 1.474-.59 1.474-1.475v-3.981c0-.885-.59-1.475-1.474-1.623z"
        fill="#fff"
      />
      <path
        d="M91.429 10.028h-65.77V4.424C25.659 1.917 23.742 0 21.235 0h-4.129c-2.507 0-4.424 1.917-4.424 4.424v5.604H4.424C1.917 10.028 0 11.945 0 14.452v4.129c0 2.507 1.917 4.424 4.424 4.424h8.405V96h12.83V22.857h65.77c2.507 0 4.424-1.917 4.424-4.424v-3.981c0-2.507-1.917-4.424-4.424-4.424zm1.474 8.405c0 .885-.59 1.475-1.474 1.475H22.71v72.995H15.63V19.908H4.424c-.885 0-1.475-.59-1.475-1.475v-3.981c0-.885.59-1.475 1.475-1.475h11.355V4.424c0-.885.59-1.475 1.474-1.475h4.13c.884 0 1.474.59 1.474 1.475v8.405H91.43c.884 0 1.474.59 1.474 1.475v4.13z"
        className="fill-secondary"
      />
      <path
        d="M54.415 36.719c-1.475-.148-2.802-.442-2.802-1.622 0-1.18 1.327-1.77 2.654-1.77 1.475 0 2.802.738 3.097 1.622l2.36-1.18c-.738-1.916-2.212-2.654-3.982-2.801v-1.622h-2.507v1.622c-2.36.147-4.571 1.475-4.571 4.129 0 3.539 2.802 4.129 5.603 4.424 1.623.147 3.245.737 3.245 1.917 0 1.622-1.328 1.77-3.097 1.77-1.622 0-3.244-.885-3.834-2.212l-2.507 1.327c.737 2.064 2.95 3.391 5.161 3.686v1.917h2.655V46.01c3.096-.295 4.571-1.917 4.571-4.571 0-3.54-3.097-4.424-6.046-4.719z"
        className="fill-primary"
      />
    </svg>
  );
}

export default IllustrationEstimatedMarketValue;
